import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { AllLocationResponseModel, ColumnsDropDownResponseModel, CreateLocationsResponseModel, LocationDetails, LocationDto, LocationRequest, LocationResponse, LocationResponseModel } from '@gtpl/shared-models/masters';
import { Injectable } from '@nestjs/common';
import { LocationsDtoActive } from './dto/location-active';
import { locationsAdapter } from './dto/location-adapter';
import { LocationsDTO } from './dto/location-dto';
import { LocationsRepository } from './dto/location-repository';
import { RackZoneRequest } from './dto/rack-zone.request';
import { Locations } from './location.entity';
import {ColumnService, LevelService, RackService} from '@gtpl/shared-services/masters';
import { Sample } from './sample.entity';
import { InjectRepository } from '@nestjs/typeorm';
import { Repository } from 'typeorm';
@Injectable()
export class LocationsService {
   
    constructor(
        private repository: LocationsRepository, 
        private adapter: locationsAdapter,
        private rackService:RackService,
        private columnService:ColumnService,
        private levelService:LevelService,
        @InjectRepository(Sample) private sampleEnt: Repository<Sample>
        ) {

    }


    async CreateLocations(details: LocationDto, isUpdate: boolean): Promise<CreateLocationsResponseModel> {
        try{
            console.log(isUpdate);
            if (!isUpdate) {
                const locationEntity = await this.getLocation(details.rackId,details.columnId,details.levelId,details.zoneId);
                // console.log('if'+locationEntity);
                if (locationEntity) {
                    throw new ErrorResponse(11104, 'location  already exists');
                }
            }
            else{
                const locationEntityData = await this.getLocation(details.rackId,details.columnId,details.levelId,details.zoneId);
                console.log(locationEntityData);
                console.log(details);
                // if (locationEntity) {
                    if(locationEntityData.locationId != details.locationId){
                        throw new ErrorResponse(11104, 'location  already exists');
                    }
                // }
            }
            console.log(details);

            const rackCodeData = await this.rackService.getRacksForRackId({rackId:details.rackId});
            const columnCode = await this.columnService.getColumnById({columnsId:details.columnId});
            const levelCode = await this.levelService.getLevelByLevelId({levelId:details.levelId});

            console.log('rackCodeData'+rackCodeData.rackCode);
            console.log('columnCode'+columnCode.columnsCode);
            console.log('levelCode'+levelCode.data.levelCode);

            const convertedEntity = await this.adapter.convertDtoToEntity(details,rackCodeData.rackCode,columnCode.columnsCode,levelCode.data.levelCode);
            const response = await this.repository.save(convertedEntity);
            if (response) {
                const data = new LocationDto(response.rackId,response.zoneId,response.levelId,response.columnId,response.locationStatus,response.locationName,response.createdUser, response.locationId, response.isActive,response.updatedUser,response.versionFlag);
                return new CreateLocationsResponseModel(true, 2234, 'location Details Created Successfully',data )
            } else {
                throw new ErrorResponse(9999, 'Failed To Create');
            }
        } catch (error) {
            console.log(error)
            throw error;
        }
    }

    async getAllLocations(): Promise<AllLocationResponseModel> {
        const responseDate = await this.repository.find({relations:['zoneMasterInfo', 'rackInfo', 'levelInfo','columnInfo'], order:{locationName:"ASC"}
    });

        const locationDetails: LocationDetails[] = [];
        if (responseDate.length > 0) {
            responseDate.forEach((location) => {
                const locationData = new LocationDetails(location.rackInfo.rackId, location.zoneMasterInfo.zoneId,location.levelInfo.levelId, location.columnInfo.columnsId,location.rackInfo.rackCode,location.zoneMasterInfo.zoneName,location.levelInfo.levelName,location.columnInfo.columnsCode,location.locationStatus,location.locationName,location.createdUser, location.locationId, location.isActive, location.updatedUser,location.versionFlag);
                locationDetails.push(locationData);
            })
            return new AllLocationResponseModel(true, 2234, 'location Details Retrived Successfully', locationDetails)
        } else {
            throw new ErrorResponse(9999, 'No Data Found');
        }
    }


    async getRecordByLocationsId(id: number): Promise<LocationResponseModel> {
        const responseData = await this.repository.findOne({ where: { locationId: id } });

        if (responseData) {
            const data = new LocationDto(responseData.rackId,responseData.zoneId, responseData.levelId,responseData.columnId, responseData.locationStatus, responseData.locationName,responseData.createdUser,responseData.locationId,responseData.isActive,responseData.updatedUser,responseData.versionFlag);
            return new LocationResponseModel(true, 7879, 'Data Retrived Successfully', data);
        } else {
            throw new ErrorResponse(9999, 'No Data Found');
        }
    }
    async getAllLocationsByZoneAndRack(rackZoneRequest: RackZoneRequest): Promise<LocationResponseModel> {
        const responseData = await this.repository.findOne({ where: { rackId: rackZoneRequest.rackId, zoneId: rackZoneRequest.zoneId} });

        if (responseData) {
            const data = new LocationDto(responseData.rackId,responseData.zoneId, responseData.levelId,responseData.columnId, responseData.locationStatus, responseData.locationName,responseData.createdUser,responseData.locationId,responseData.isActive,responseData.updatedUser,responseData.versionFlag);
            return new LocationResponseModel(true, 7879, 'Data Retrived Successfully', data);
        } else {
            throw new ErrorResponse(9999, 'No Data Found');
        }
    }

    async getLocation(rackId: number,columnId:number,levelId:number,zoneId:number): Promise<Locations> {
    
        const response = await this.repository.findOne({
            where: { rackId: rackId, columnId:columnId, levelId:levelId , zoneId:zoneId},
        });
        console.log(response)
        if (response) {
            return response;
        } else {
            return null;
        }
    }
    async getLocationData(locationId: number): Promise<Locations> {
        
        const response = await this.repository.findOne({
            where: { locationId: locationId },
        });
        if (response) {
            return response;
        } else {
            return null;


        }
    }
    async getLocationById(locationRequest: LocationRequest): Promise<LocationResponseModel> {
        try{
            const locationData = await this.repository.findOne({
             where: { locationId: locationRequest.locationId },
            });
            const locationDto = new LocationDto(locationData.rackId,locationData.zoneId,locationData.levelId,locationData.columnId,locationData.locationStatus,locationData.locationName,locationData.createdUser,locationData.locationId,locationData.isActive,locationData.updatedUser,locationData.versionFlag)
            const response = new LocationResponseModel(true,1101,"Pallet retrived successfully",locationDto)
            return response;
        } catch (err) {
            return err;
        }
    }
    async activateorDeactivateLocation(locationAct: LocationsDtoActive): Promise<LocationResponse> {
        console.log(locationAct);
        try {
            const locationExists = await this.getLocationData(locationAct.locationId);
            if (locationExists) {
                if (locationAct.versionFlag !== locationExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current locations information.Refresh and try again');
                } else {

                    const locationSatatus = await this.repository.update(
                        { locationId: locationAct.locationId },
                        { isActive: locationAct.isActive, updatedUser: locationAct.updatedUser });
                    const updatedRecord = await this.getRecordByLocationsId(locationAct.locationId);
                    if (locationExists.isActive) {
                        if (locationSatatus.affected) {
                            const locationResponse: LocationResponse = new LocationResponse(true, 10115, 'location is de-activated successfully');
                            return locationResponse;
                        } else {
                            throw new ErrorResponse(10111, 'location is already deactivated');
                        }
                    } else {
                        if (locationSatatus.affected) {
                            const locationcatResponse: LocationResponse = new LocationResponse(true, 10114, 'location is activated successfully', updatedRecord.data);
                            return locationcatResponse;
                        } else {
                            throw new ErrorResponse(10112, 'location is already  activated');
                        }
                    }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

    async logTemeperature(headers: any, body: any): Promise<any> {
        const sampleObj = new Sample();
        sampleObj.body = body;
        sampleObj.headers = headers;
        await this.sampleEnt.save(sampleObj);
    }



}
